import * as actionTypes from "./actionTypes";
import * as types from "./types";

//Inbound Webhook
export const postInboundWebhookRequest = (payload: types.IInboundWebhookParams): types.PostInboundWebhookTriggersRequest => ({
    type: actionTypes.POST_INBOUND_WEBHOOK_REQUEST,
    payload
});

export const postInboundWebhookSuccess = (payload: types.IPostInboundWebhookSuccessPayload): types.PostInboundWebhookTriggersSuccess => ({
    type: actionTypes.POST_INBOUND_WEBHOOK_SUCCESS,
    payload
});

export const postInboundWebhookFailure = (payload: types.IPostInboundWebhookFailurePayload): types.PostInboundWebhookTriggersFailure => ({
    type: actionTypes.POST_INBOUND_WEBHOOK_FAILURE,
    payload
});

//Outbound Webhook
export const postOutboundWebhookRequest = (payload: types.IOutboundWebhookParams): types.PostOutboundWebhookTriggersRequest => ({
    type: actionTypes.POST_OUTBOUND_WEBHOOK_REQUEST,
    payload
});

export const postOutboundWebhookSuccess = (payload: types.IPostOutboundWebhookSuccessPayload): types.PostOutboundWebhookTriggersSuccess => ({
    type: actionTypes.POST_OUTBOUND_WEBHOOK_SUCCESS,
    payload
});

export const postOutboundWebhookFailure = (payload: types.IPostOutboundWebhookFailurePayload): types.PostOutboundWebhookTriggersFailure => ({
    type: actionTypes.POST_OUTBOUND_WEBHOOK_FAILURE,
    payload
});

// Fetch Outbound Webhook List
export const fetchOutboundWebhookListReq = (params: types.IOutboundWebhookListParams): types.FetchOutboundWebhookListReq => ({
    type: actionTypes.FETCH_OUTBOUND_WEBHOOK_LIST_REQUEST,
    params,
});

export const fetchOutboundWebhookListSuccess = (
    payload: types.FetchOutboundWebhookListSuccessPayload
): types.FetchOutboundWebhookListSuccess => ({
    type: actionTypes.FETCH_OUTBOUND_WEBHOOK_LIST_SUCCESS,
    payload,
});

export const fetchOutboundWebhookListFailure = (
    payload: types.FetchOutboundWebhookListFailurePayload
): types.FetchOutboundWebhookListFailure => ({
    type: actionTypes.FETCH_OUTBOUND_WEBHOOK_LIST_FAILURE,
    payload,
});

// Put Inbound API
export const putInboundWebhookRequest = (
    eventId: string,
    payload: types.IPutInboundReq
): types.PutInboundRequest => ({
    type: actionTypes.PUT_INBOUND_WEBHOOK_REQUEST,
    eventId,
    payload
});

export const putInboundWebhookSuccess = (
    payload: types.IPutInboundSuccessPayload
): types.PutInboundSuccess => ({
    type: actionTypes.PUT_INBOUND_WEBHOOK_SUCCESS,
    payload,
});

export const putInboundWebhookFailure = (
    payload: types.IPutInboundFailurePayload
): types.PutInboundFailure => ({
    type: actionTypes.PUT_INBOUND_WEBHOOK_FAILURE,
    payload,
});

// Put Outbound API
export const putOutboundWebhookRequest = (
    eventId: string,
    payload: types.IPutOutboundReq
): types.PutOutboundRequest => ({
    type: actionTypes.PUT_OUTBOUND_WEBHOOK_REQUEST,
    eventId,
    payload
});

export const putOutboundWebhookSuccess = (
    payload: types.IPutOutboundSuccessPayload
): types.PutOutboundSuccess => ({
    type: actionTypes.PUT_OUTBOUND_WEBHOOK_SUCCESS,
    payload,
});

export const putOutboundWebhookFailure = (
    payload: types.IPutOutboundFailurePayload
): types.PutOutboundFailure => ({
    type: actionTypes.PUT_OUTBOUND_WEBHOOK_FAILURE,
    payload,
});

// DELETE Outbound

export const deleteOutboundWebhookReq = (
    params: string
): types.DeleteOutboundRequest => ({
    type: actionTypes.DELETE_OUTBOUND_WEBHOOK_REQUEST,
    params,
});

export const deleteOutboundSuccess = (
    success: types.IDeleteOutboundSuccess
): types.DeleteOutboundSuccess => ({
    type: actionTypes.DELETE_OUTBOUND_WEBHOOK_SUCCESS,
    success,
});

export const deleteOutboundFailure = (
    payload: types.IDeleteOutboundFailurePayload
): types.DeleteOutboundFailure => ({
    type: actionTypes.DELETE_OUTBOUND_WEBHOOK_FAILURE,
    payload,
});